<template>
  <div id="app" class="imagecontainer">
    <!-- Skjermleser-intro -->
    <div class="sr-only" role="note">
      {{
        (locale && locale.app_beskrivelse && locale.app_beskrivelse[lang]) ||
        "Radioaktivitet - interaktiv lab. Bruk Tab for å navigere mellom kontroller, og piltaster for å velge innad i grupper."
      }}
    </div>

    <!-- Info- og fullskjermknapp er først i DOM = første Tab-stopp -->
    <img
      class="infobutton"
      style="position: absolute; z-index: 999"
      :style="{
        width: genericbuttonsize + 'px',
        left: info_button_left + 'px',
        top: info_button_top + 'px',
      }"
      id="infobutton"
      role="button"
      :aria-label="(locale && locale.info_knapp && locale.info_knapp[lang]) || 'Informasjon'"
      tabindex="0"
      alt=""
      :src="require('@/assets/img/GeneriskKnapp_aktiv.png')"
      @click="showInfo"
      @keydown.enter.prevent="showInfo"
      @keydown.space.prevent="showInfo"
    />
    <i
      class="fas fa-info"
      :class="{ 'fa-2x': windowWidth >= 900 }"
      style="position: absolute; z-index: 999; color: white"
      :style="{
        left: info_button_left + genericbuttonsize / 2 + 'px',
        top: info_button_top + genericbuttonsize / 2 + 'px',
      }"
      id="infobutton_span"
      aria-hidden="true"
      @click="showInfo"
    ></i>
    <img
      class="infobutton"
      style="position: absolute; z-index: 999"
      :style="{
        width: genericbuttonsize + 'px',
        left: fullscreen_button_left + 'px',
        top: fullscreen_button_top + 'px',
      }"
      id="fullscreenbutton"
      role="button"
      :aria-label="(locale && locale.fullscreen_knapp && locale.fullscreen_knapp[lang]) || 'Fullskjerm'"
      tabindex="0"
      alt=""
      :src="require('@/assets/img/GeneriskKnapp_aktiv.png')"
      @click="toggleFullScreen"
      @keydown.enter.prevent="toggleFullScreen"
      @keydown.space.prevent="toggleFullScreen"
    />
    <i
      class="fas fa-expand"
      :class="{ 'fa-2x': windowWidth >= 900 }"
      style="position: absolute; z-index: 999; color: white"
      :style="{
        left: fullscreen_button_left + genericbuttonsize / 2 + 'px',
        top: fullscreen_button_top + genericbuttonsize / 2 + 'px',
      }"
      id="fullscreenbutton_span"
      aria-hidden="true"
      @click="toggleFullScreen"
    ></i>

    <!-- ARIA Live regions for status messages -->
    <!-- Live region for material selection -->
    <div role="status" aria-live="polite" aria-atomic="true" class="sr-only">
      {{ materialStatusMessage }}
    </div>

    <!-- Live region for radiation source selection -->
    <div role="status" aria-live="polite" aria-atomic="true" class="sr-only">
      {{ radiationStatusMessage }}
    </div>


    <!-- <div
      id="toggleonoff"
      class="hiddenfromview"
      @click="toggleOnOff"
      :style="{
        top: toggleonoff_top + 'px',
        left: toggleonoff_left + 'px',
        width: toggleonoff_width + 'px',
        height: toggleonoff_height + 'px',
      }"
    ></div> -->
    <!-- <div id="on_button" class="imagecontainer" v-if="on"></div>
    <div id="off_button" class="imagecontainer" v-else></div> -->
    <i
      class="fas fa-caret-down linjal_arrow"
      :style="{
        top: linjal_arrow_y + 'px',
        left: linjal_arrow_x + 'px',
      }"
    ></i>
    <!-- <div id="counter_button" class="imagecontainer" v-if="on && counter"></div> -->
    <div
      class="overskrift"
      :style="{
        left: overskrift_left + 'px',
        top: overskrift_top + 'px',
      }"
    >
      <h1>Radioaktivitet</h1>
      <h2>Interaktiv lab</h2>
    </div>
    <!-- <div id="geiger" class="imagecontainer"></div> -->
    <!-- <div id="speaker_signals" class="imagecontainer"></div> -->
    <img
      id="material"
      v-if="backgroundMaterial"
      :src="backgroundMaterial"
      alt="Viser material type"
      style="position: absolute"
      :style="{
        width: veggmaterial_width + 'px',
        left: veggmaterial_left + 'px',
        top: veggmaterial_top + 'px',
      }"
    />
    <img
      id="radiation"
      v-if="backgroundRadiation"
      :src="backgroundRadiation"
      alt="Viser strålingskilde"
      style="position: absolute"
      :style="{
        width: radiation_width + 'px',
        left: radiation_left + 'px',
        top: radiation_top + 'px',
      }"
    />
    <!-- <div
      id="radiation"
      class="imagecontainer"
      :style="{
        backgroundImage: backgroundRadiation,
      }"
    ></div> -->
    <!-- ARIA Live region for counter value - oppdateres hvert 3. sekund, ikke ved hvert klikk -->
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      class="sr-only"
    >
      {{
        announced_counter_value !== null
          ? announced_counter_done
            ? (locale && locale.counter_ferdig[lang]) + ': ' + announced_counter_value
            : (locale && locale.counter_status[lang]) + ': ' + announced_counter_value
          : ''
      }}
    </div>

    <!-- ARIA Live region for countdown -->
    <div
      v-if="on && counter && countdown_value > 0"
      role="timer"
      aria-live="off"
      aria-atomic="true"
      class="sr-only"
    >
      {{ countdown_value }} {{ locale && locale.sekunder_igjen[lang] }}
    </div>

    <div
      v-if="on && counter"
      id="geigercountdown"
      :style="{
        width: countdownvalue_width + 'px',
        height: countdownvalue_height + 'px',
        left: countdownvalue_x + 'px',
        top: countdownvalue_y + 'px',
      }"
    >
      <span id="geigercountdown_span">
        {{ countdown_value }}
      </span>
    </div>
    <div
      id="main-content"
      class="sr-only"
      aria-label="Radioaktivitet - Interaktiv lab"
    ></div>
    <div
      id="geigercounter"
      v-if="on"
      :style="{
        width: countervalue_width + 'px',
        height: countervalue_height + 'px',
        left: countervalue_x + 'px',
        top: countervalue_y + 'px',
      }"
    >
      <span id="geigercounter_span">
        {{ counter_value }}
      </span>
    </div>

    <!-- Radiogroup landmark for strålekildevalg -->
    <div
      id="radiation-selector"
      role="radiogroup"
      :aria-label="
        (locale &&
          locale.velg_radioaktiv_kilde &&
          locale.velg_radioaktiv_kilde[lang]) ||
        'Velg radioaktiv kilde'
      "
      class="sr-only"
      aria-hidden="false"
    ></div>

    <div
      v-for="straaleobjekt in visibleRadation"
      class="straaleobjekt_container dropdown"
      :key="straaleobjekt.label"
      role="radio"
      :aria-checked="
        (selectedstraalingsobjekt === straaleobjekt.value).toString()
      "
      :aria-label="straaleobjekt.label"
      :tabindex="visibleRadation.indexOf(straaleobjekt) === focusedRadiationIndex ? 0 : -1"
      :style="{
        width: radiationsize + 'px',
        height: radiationsize + 'px',
        left: straalingsobjekter[straaleobjekt.value].iconleft + 'px',
        top: radiationtop + 'px',
      }"
      @click="focusedRadiationIndex = visibleRadation.indexOf(straaleobjekt); selectedRadiation(straaleobjekt.value)"
      @keydown.enter.prevent="confirmRadiation"
      @keydown.space.prevent="confirmRadiation"
      @keydown.down.prevent="selectNextRadiation"
      @keydown.up.prevent="selectPrevRadiation"
      @keydown.right.prevent="selectNextRadiation"
      @keydown.left.prevent="selectPrevRadiation"
      @keydown.home.prevent="selectFirstRadiation"
      @keydown.end.prevent="selectLastRadiation"
    >
      <img
        class="straaleobjekt"
        :class="{
          glow:
            selectedstraalingsobjekt == straaleobjekt.value ||
            straaleobjekt.hover,
        }"
        alt=""
        :style="{
          width: radiationsize + 'px',
        }"
        :id="straaleobjekt.value"
        :src="
          selectedstraalingsobjekt == straaleobjekt.value || straaleobjekt.hover
            ? straalingsobjekter[straaleobjekt.value]['activeicon']
            : straalingsobjekter[straaleobjekt.value]['inactiveicon']
        "
      />
      <span
        class="straaleobjekt_span"
        :class="{
          hover: selectedstraalingsobjekt == straaleobjekt.value,
        }"
        :id="straaleobjekt.value + '_span'"
        >{{ straaleobjekt.label }}</span
      >
      <div class="dropdown-content slim">{{ straaleobjekt.label }}</div>
    </div>

    <img
      class="genericbutton"
      :style="{
        width: genericbuttonsize + 'px',
        left: button_2cm + 'px',
        top: genericbuttontop + 'px',
      }"
      id="button_2cm"
      role="radio"
      :aria-checked="(selectedavstand === 'kort').toString()"
      :aria-label="locale && locale.knapp_for_aa_velge_2_cm_avstand[lang]"
      :tabindex="focusedAvstandIndex === 0 ? 0 : -1"
      alt=""
      :src="
        selectedavstand == 'kort'
          ? require('@/assets/img/GeneriskKnapp_aktiv_ring.png')
          : require('@/assets/img/GeneriskKnapp_aktiv.png')
      "
      @click="focusedAvstandIndex = 0; selectedavstand = 'kort'"
      @keydown.enter.prevent="focusedAvstandIndex = 0; confirmAvstand()"
      @keydown.space.prevent="focusedAvstandIndex = 0; confirmAvstand()"
      @keydown.right.prevent="focusAvstand(1)"
      @keydown.left.prevent="focusAvstand(0)"
    />
    <span
      class="genericbutton_span"
      :class="{
        hover: selectedavstand == 'kort',
      }"
      :style="{
        left: button_2cm + genericbuttonsize / 2 + 'px',
        top: genericbuttontop + genericbuttonsize / 2 + 'px',
      }"
      id="button_2cm_span"
      aria-hidden="true"
      @click="selectedavstand = 'kort'"
      >2 cm</span
    >
    <img
      class="genericbutton"
      :style="{
        width: genericbuttonsize + 'px',
        left: button_10cm + 'px',
        top: genericbuttontop + 'px',
      }"
      id="button_10cm"
      role="radio"
      :aria-checked="(selectedavstand === 'lang').toString()"
      :aria-label="locale && locale.knapp_for_aa_velge_10_cm_avstand[lang]"
      :tabindex="focusedAvstandIndex === 1 ? 0 : -1"
      alt=""
      :src="
        selectedavstand == 'lang'
          ? require('@/assets/img/GeneriskKnapp_aktiv_ring.png')
          : require('@/assets/img/GeneriskKnapp_aktiv.png')
      "
      @click="focusedAvstandIndex = 1; selectedavstand = 'lang'"
      @keydown.enter.prevent="focusedAvstandIndex = 1; confirmAvstand()"
      @keydown.space.prevent="focusedAvstandIndex = 1; confirmAvstand()"
      @keydown.right.prevent="focusAvstand(1)"
      @keydown.left.prevent="focusAvstand(0)"
    />
    <span
      class="genericbutton_span"
      :class="{
        hover: selectedavstand == 'lang',
      }"
      :style="{
        left: button_10cm + genericbuttonsize / 2 + 'px',
        top: genericbuttontop + genericbuttonsize / 2 + 'px',
      }"
      id="button_10cm_span"
      aria-hidden="true"
      @click="selectedavstand = 'lang'"
      >10 cm</span
    >


    <div
      id="linjal_2cm"
      v-if="
        (selectedavstand == 'kort' && !hover10cm) ||
        (selectedavstand == 'lang' && hover2cm)
      "
      class="imagecontainer"
    ></div>
    <div id="linjal_10cm" v-else class="imagecontainer"></div>

    <div
      class="info tekst dropdown"
      id="info_material"
      :style="{
        left: info_material_left + 'px',
        top: info_material_top + 'px',
      }"
    >
      <span class="h2">{{ locale && locale.velg_materiale[lang] }}</span>
      <span style="margin-right: 0.2em">:</span>
      <i class="fas fa-arrow-down"></i>
      <div
        class="dropdown-content"
        v-html="locale && locale.velg_materiale_dropdown[lang]"
      ></div>
    </div>
    <div
      class="info tekst dropdown"
      id="info_avstand"
      :style="{
        left: info_avstand_left + 'px',
        top: info_avstand_top + 'px',
      }"
    >
      <span class="h2" style="color: white">{{
        locale && locale.velg_avstand[lang]
      }}</span>
      <span style="margin-right: 0.2em; color: white">:</span>
      <i class="fas fa-arrow-down" style="color: white"></i>
      <div class="dropdown-content">
        {{ locale && locale.velg_avstand_dropdown[lang] }}
      </div>
    </div>
    <div
      class="info tekst dropdown"
      id="info_kilde"
      :style="{
        left: info_kilde_left + 'px',
        top: info_kilde_top + 'px',
      }"
    >
      <span class="h2" style="color: white">{{
        locale && locale.velg_radioaktiv_kilde[lang]
      }}</span>
      <span style="margin-right: 0.2em; color: white">:</span>
      <i class="fas fa-arrow-down" style="color: white"></i>
      <div
        class="dropdown-content"
        v-html="locale && locale.velg_radioaktiv_kilde_dropdown[lang]"
      ></div>
    </div>

    <div
      class="info tekst dropdown left"
      id="info_av_og_paa"
      :style="{
        left: info_av_og_paa_left + 'px',
        top: info_av_og_paa_top + 'px',
      }"
    >
      <span class="h2">{{
        locale && locale.slaa_paa_og_les_maaling[lang]
      }}</span>
      <span style="margin-right: 0.2em">:</span>
      <i class="fas fa-arrow-down"></i>
      <div class="dropdown-content">
        {{ locale && locale.slaa_paa_og_les_maaling_dropdown[lang] }}
      </div>
    </div>
    <!-- Radiogroup landmark for materialevalg -->
    <div
      id="material-selector"
      role="radiogroup"
      :aria-label="
        (locale && locale.velg_materiale && locale.velg_materiale[lang]) ||
        'Velg materiale'
      "
      class="sr-only"
      aria-hidden="false"
    ></div>

    <div
      v-for="veggobjekt in visibleMaterials"
      class="veggmaterial_container dropdown"
      :key="veggobjekt.label[lang]"
      role="radio"
      :aria-checked="(selectedveggobjekt === veggobjekt.value).toString()"
      :aria-label="veggobjekt.label[lang]"
      :tabindex="visibleMaterials.indexOf(veggobjekt) === focusedMaterialIndex ? 0 : -1"
      :style="{
        width: materialsize + 'px',
        height: materialsize + 'px',
        left: veggmaterial[veggobjekt.value].iconleft + 'px',
        top: materialtop + 'px',
      }"
      @click="focusedMaterialIndex = visibleMaterials.indexOf(veggobjekt); selectMaterial(veggobjekt.value)"
      @keydown.enter.prevent="confirmMaterial"
      @keydown.space.prevent="confirmMaterial"
      @keydown.down.prevent="selectNextMaterial"
      @keydown.up.prevent="selectPrevMaterial"
      @keydown.right.prevent="selectNextMaterial"
      @keydown.left.prevent="selectPrevMaterial"
      @keydown.home.prevent="selectFirstMaterial"
      @keydown.end.prevent="selectLastMaterial"
    >
      <img
        class="veggmaterial"
        :class="{
          hover: selectedveggobjekt == veggobjekt.value || veggobjekt.hover,
        }"
        :style="{
          width: materialsize + 'px',
        }"
        alt=""
        :id="veggobjekt.value"
        :src="
          selectedveggobjekt == veggobjekt.value
            ? veggmaterial[veggobjekt.value]['activeicon']
            : veggmaterial[veggobjekt.value]['inactiveicon']
        "
      />

      <span
        class="veggmaterial_span"
        :class="{
          hover: selectedveggobjekt == veggobjekt.value,
        }"
        :id="veggobjekt.value + '_span'"
        >{{ veggobjekt.kjemisk || veggobjekt.label[lang] }}</span
      >

      <div class="dropdown-content slim" style="white-space: nowrap">
        <template v-if="veggobjekt.kjemisk"
          >{{ veggobjekt.kjemisk }} -</template
        >
        {{ veggobjekt.label[lang] }}
      </div>
    </div>

    <!-- Geigerteller-gruppe: sist i Tab-rekkefølgen -->
    <!-- Roving tabindex: Tab inn i gruppen, piltaster internt -->
    <div
      role="group"
      :aria-label="(locale && locale.geigerteller_gruppe && locale.geigerteller_gruppe[lang]) || 'Geigerteller'"
      class="sr-only-group"
    >
      <!-- 0: av/på, 1: lyd, 2: start -->
      <img
        :src="on ? powerbutton_icon_on : powerbutton_icon_off"
        id="toggleonoff"
        role="button"
        :aria-label="locale && locale.knapp_for_aa_slaa_av_og_paa_geigerteller[lang]"
        :aria-pressed="on.toString()"
        :tabindex="geigerFocusIndex === 0 ? 0 : -1"
        alt=""
        style="position: absolute"
        :style="{
          width: powerbutton_icon_width + 'px',
          left: powerbutton_icon_left + 'px',
          top: powerbutton_icon_top + 'px',
        }"
        @click="geigerFocusIndex = 0; toggleOnOff()"
        @keydown.enter.prevent="geigerFocusIndex = 0; toggleOnOff()"
        @keydown.space.prevent="geigerFocusIndex = 0; toggleOnOff()"
        @keydown.right.prevent="geigerFocusNext"
        @keydown.down.prevent="geigerFocusNext"
        @keydown.left.prevent="geigerFocusPrev"
        @keydown.up.prevent="geigerFocusPrev"
      />
      <img
        :src="speaker_sound ? speaker_icon_on : speaker_icon_off"
        id="togglespeaker"
        role="button"
        :aria-label="locale && locale.knapp_for_aa_slaa_av_paa_lyd[lang]"
        :aria-pressed="speaker_sound.toString()"
        :tabindex="geigerFocusIndex === 1 ? 0 : -1"
        alt=""
        style="position: absolute"
        :style="{
          width: speaker_width + 'px',
          left: speaker_left + 'px',
          top: speaker_top + 'px',
        }"
        @click="geigerFocusIndex = 1; toggleSpeaker()"
        @keydown.enter.prevent="geigerFocusIndex = 1; toggleSpeaker()"
        @keydown.space.prevent="geigerFocusIndex = 1; toggleSpeaker()"
        @keydown.right.prevent="geigerFocusNext"
        @keydown.down.prevent="geigerFocusNext"
        @keydown.left.prevent="geigerFocusPrev"
        @keydown.up.prevent="geigerFocusPrev"
      />
      <div
        id="togglecounter"
        class="hiddenfromview"
        :class="{ show: counter }"
        v-show="on"
        role="button"
        :aria-label="locale && locale.knapp_for_aa_slaa_av_og_paa_teller[lang]"
        :aria-pressed="counter.toString()"
        :tabindex="on && geigerFocusIndex === 2 ? 0 : -1"
        @click="geigerFocusIndex = 2; toggleCounter()"
        @keydown.enter.prevent="geigerFocusIndex = 2; toggleCounter()"
        @keydown.space.prevent="geigerFocusIndex = 2; toggleCounter()"
        @keydown.right.prevent="geigerFocusNext"
        @keydown.down.prevent="geigerFocusNext"
        @keydown.left.prevent="geigerFocusPrev"
        @keydown.up.prevent="geigerFocusPrev"
        :style="{
          top: togglecounter_top + 'px',
          left: togglecounter_left + 'px',
          width: togglecounter_width + 'px',
          height: togglecounter_height + 'px',
        }"
      ></div>
    </div>

    <img
      :src="count_on_img"
      v-if="on && counter"
      alt="Teller er på"
      style="position: absolute"
      :style="{
        width: count_on_width + 'px',
        left: count_on_left + 'px',
        top: count_on_top + 'px',
      }"
    />

    <img
      :src="speaker_signal_icon"
      v-if="speaker_sound && speaker_signal_show"
      alt="Lydsignal"
      style="position: absolute; transform: translate(25%, -15%)"
      :style="{
        width: speaker_signal_width + 'px',
        left: speaker_left + 'px',
        top: speaker_top + 'px',
      }"
      @click="speaker_sound = !speaker_sound"
    />
    <modal
      :locale="locale"
      :lang="lang"
      v-if="modal.show"
      @close="modal.show = false"
    ></modal>

    <!-- Focus wrap sentinel: fanger Tab fra siste element og sender tilbake til første -->
    <span
      class="sr-only"
      tabindex="0"
      @focus="wrapFocusToStart"
      aria-hidden="true"
    ></span>
  </div>
</template>

<script>
import axios from "axios";
import modal from "./components/modal";
export default {
  name: "App",
  components: { modal },
  data() {
    return {
      lang: "nb",
      locale: null,
      data: null,
      windowWidth: 0,
      windowHeight: 0,
      selectedstraalingsobjekt: "ingen",
      selectedveggobjekt: "ingen",
      selectedavstand: "kort",
      currentvalue: 0,
      normalWidth: 1920,
      normalHeight: 1080,
      normalRatio: 1920 / 1080,
      calculatedWidth: 0,
      calculatedHeight: 0,
      airgapAbove: 0,
      airgapLeft: 0,
      onoff_x: 0,
      onoff_y: 0,
      radius_threshold: 0,
      on: false,
      counter: false,
      countertimer: null,
      counter_check_value: null,
      counter_value: 0,
      countdown_timer: 0,
      countdown_start: 0,
      countdown_value: 0,
      counter_iteration: 0,
      announced_counter_value: null,
      announced_counter_done: false,
      announce_timer: null,
      powerbutton_icon_off: require("@/assets/img/Knapp_Av_crop.png"),
      powerbutton_icon_on: require("@/assets/img/Knapp_Pa_crop2.png"),
      powerbutton_icon_width: 0,
      powerbutton_icon_left: 0,
      powerbutton_icon_top: 0,
      speaker_sound: false,
      speaker_icon_on: require("@/assets/img/speaker_icon_on.png"),
      speaker_icon_off: require("@/assets/img/speaker_icon_off.png"),
      speaker_signal_icon: require("@/assets/img/SpeakerSignals_begge.png"),
      speaker_width: 0,
      speaker_signal_width: 0,
      speaker_signal_timeout: null,
      speaker_signal_show: false,
      speaker_left: 0,
      speaker_top: 0,
      targetValue: 0,
      choose_radiation_text_x: 0,
      choose_radiation_text_y: 0,
      geigercountdown_span_x: 0,
      geigercountdown_span_y: 0,
      countdownvalue_width: 0,
      countdownvalue_height: 0,
      countdownvalue_x: 0,
      countdownvalue_y: 0,
      countervalue_width: 0,
      countervalue_height: 0,
      countervalue_x: 0,
      countervalue_y: 0,
      count_on_img: require("@/assets/img/Count_ON_Crop.png"),
      count_on_width: 0,
      count_on_left: 0,
      count_on_top: 0,
      materialsize: 124,
      materialtop: 0,
      radiationsize: 168,
      radiationtop: 0,
      hover2cm: false,
      hover10cm: false,
      genericbuttonsize: 135,
      genericbuttontop: 0,
      button_2cm: 0,
      button_10cm: 0,
      fullscreen_button_left: 1788,
      fullscreen_button_top: 25,
      info_button_left: 1788,
      info_button_top: 25,
      info_material_left: 0,
      info_material_top: 0,
      info_kilde_left: 0,
      info_kilde_top: 0,
      info_avstand_left: 0,
      info_avstand_top: 0,
      info_av_og_paa_left: 0,
      info_av_og_paa_top: 0,
      linjal_arrow_x: 0,
      linjal_arrow_y: 0,
      overskrift_left: 0,
      overskrift_top: 0,
      modal: {
        show: false,
      },
      veggmaterial_left: 0,
      veggmaterial_top: 0,
      veggmaterial_width: 0,
      veggmaterial: {
        aluminium: {
          stand: require("@/assets/img/Aluminiumrfolie.svg"),
          activeicon: require("@/assets/img/aluminium_aktiv_svart.png"),
          inactiveicon: require("@/assets/img/aluminium_aktiv.png"),
          iconleft: 0,
        },
        bly: {
          stand: require("@/assets/img/Bly.svg"),
          activeicon: require("@/assets/img/Bly_aktiv_svart.png"),
          inactiveicon: require("@/assets/img/Bly_aktiv.png"),
          iconleft: 0,
        },
        meat: {
          stand: require("@/assets/img/Kjott.svg"),
          activeicon: require("@/assets/img/Kjott_aktiv_svart.png"),
          inactiveicon: require("@/assets/img/Kjott_aktiv.png"),
          iconleft: 0,
        },
        kopper: {
          stand: require("@/assets/img/Kopperfolie.svg"),
          activeicon: require("@/assets/img/Kopper_aktiv_svart.png"),
          iconleft: 0,
          inactiveicon: require("@/assets/img/Kopper_aktiv.png"),
        },
        papir: {
          stand: require("@/assets/img/Papir.svg"),
          activeicon: require("@/assets/img/Papir_aktiv_svart.png"),
          inactiveicon: require("@/assets/img/Papir_aktiv.png"),
          iconleft: 0,
        },
      },
      radiation_left: 0,
      radiation_top: 0,
      radiation_width: 0,
      straalingsobjekter: {
        ingen: {
          stand_2cm: require("@/assets/img/Straleror_2cm.png"),
          stand_10cm: require("@/assets/img/Straleror_10cm.png"),
        },
        alpha: {
          stand_2cm: require("@/assets/img/Straleror_2cm_alfa.svg"),
          stand_10cm: require("@/assets/img/Straleror_10cm_alfa.svg"),
          activeicon: require("@/assets/img/alfa_ring.png"),
          inactiveicon: require("@/assets/img/alfa.png"),
          iconleft: 0,
        },
        beta: {
          stand_2cm: require("@/assets/img/Straleror_2cm_beta.svg"),
          stand_10cm: require("@/assets/img/Straleror_10cm_beta.svg"),
          activeicon: require("@/assets/img/beta_ring.png"),
          inactiveicon: require("@/assets/img/beta.png"),
          iconleft: 0,
        },
        gamma: {
          stand_2cm: require("@/assets/img/Straleror_2cm_gamma.svg"),
          stand_10cm: require("@/assets/img/Straleror_10cm_gamma.svg"),
          activeicon: require("@/assets/img/gamma_ring.png"),
          inactiveicon: require("@/assets/img/gamma.png"),
          iconleft: 0,
        },
      },
      straaleror: {},
      togglecounter_width: 0,
      togglecounter_height: 0,
      togglecounter_left: 0,
      togglecounter_top: 0,

      toggleonoff_width: 0,
      toggleonoff_height: 0,
      toggleonoff_left: 0,
      toggleonoff_top: 0,

      keyUp: 38,
      keyDown: 40,
      keyLeft: 37,
      keyRight: 39,
      keyHome: 36,
      keyEnd: 35,
      geigerFocusIndex: 0,
      focusedRadiationIndex: 0,
      focusedMaterialIndex: 0,
      focusedAvstandIndex: 0,
    };
  },
  watch: {
    selectedavstand() {
      this.setValues();
    },
  },
  computed: {
    backgroundMaterial() {
      if (this.selectedveggobjekt == "ingen") {
        return "";
      } else {
        return this.veggmaterial[this.selectedveggobjekt]["stand"];
      }
    },
    backgroundRadiation() {
      if (this.selectedstraalingsobjekt == "ingen") {
        return "";
      } else {
        return this.straalingsobjekter[this.selectedstraalingsobjekt][
          this.selectedavstand == "kort" ? "stand_2cm" : "stand_10cm"
        ];
      }
    },
    visibleMaterials() {
      if (this.data) {
        return this.data.veggobjekter.filter((el) => el.value != "ingen");
      } else {
        return [];
      }
    },
    visibleRadation() {
      if (this.data) {
        return this.data.straaleobjekter.filter((el) => el.value != "ingen");
      } else {
        return [];
      }
    },

    materialStatusMessage() {
      if (!this.locale) return "";

      if (this.selectedveggobjekt === "ingen") {
        return this.locale.ingen_materiale[this.lang];
      }

      // Find the selected material
      if (this.data) {
        const selected = this.data.veggobjekter.find(
          (v) => v.value === this.selectedveggobjekt,
        );

        if (selected) {
          return `${this.locale.valgt_materiale[this.lang]}: ${
            selected.label[this.lang]
          }`;
        }
      }

      return "";
    },

    radiationStatusMessage() {
      if (!this.locale) return "";

      if (this.selectedstraalingsobjekt === "ingen") {
        return this.locale.ingen_straalekilde[this.lang];
      }

      // Find the selected radiation source
      if (this.data) {
        const selected = this.data.straaleobjekter.find(
          (s) => s.value === this.selectedstraalingsobjekt,
        );

        if (selected) {
          return `${this.locale.valgt_straalekilde[this.lang]}: ${
            selected.label
          }`;
        }
      }

      return "";
    },
  },

  mounted() {
    this.getData();
    window.addEventListener("keydown", this.keydown);
  },
  methods: {
    alert() {
      alert("helo");
    },
    calculateSizes() {
      this.getWindowWidth();
      this.getWindowHeight();
      this.calculateAllValuesForImage();
    },
    getData() {
      Promise.all([
        axios.get("data.json"),
        axios.get("settingsandlocale.json"),
      ]).then((results) => {
        this.data = results[0].data;
        this.locale = results[1].data;
        this.lang = this.locale.lang;
        this.$nextTick(function () {
          window.addEventListener("resize", this.calculateSizes);
          // window.addEventListener("click", this.clickedWindow);
          // window.addEventListener("mousemove", this.mousemove);

          this.calculateSizes();
        });
      });
    },
    getWindowWidth() {
      this.windowWidth = document.documentElement.clientWidth;
    },
    getWindowHeight() {
      this.windowHeight = document.documentElement.clientHeight;
    },
    calculateAllValuesForImage() {
      let windowRatio = this.windowWidth / this.windowHeight;
      let airGap = 0;
      if (windowRatio < this.normalRatio) {
        // calculate how much air is above and below.
        let calculatedHeightOfImage =
          (this.windowWidth * this.normalHeight) / this.normalWidth;
        airGap = this.windowHeight - calculatedHeightOfImage;
        this.airgapAbove = airGap / 2;
        this.airgapLeft = 0;
      } else {
        let calculatedWidthOfImage =
          (this.normalWidth * this.windowHeight) / this.normalHeight;
        airGap = this.windowWidth - calculatedWidthOfImage;
        this.airgapAbove = 0;
        this.airgapLeft = airGap / 2;
        // calculate how much air on the sides.
      }
      this.calculatedWidth = this.windowWidth - this.airgapLeft * 2;
      this.calculatedHeight = this.windowHeight - this.airgapAbove * 2;
      this.materialsize = (135 * this.calculatedWidth) / this.normalWidth;
      this.genericbuttonsize = (135 * this.calculatedWidth) / this.normalWidth;

      this.count_on_width = (85 * this.calculatedWidth) / this.normalWidth;
      this.count_on_left =
        (197 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      this.count_on_top =
        (826 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;

      this.togglecounter_width = (73 * this.calculatedWidth) / this.normalWidth;
      this.togglecounter_height =
        (91 * this.calculatedWidth) / this.normalWidth;
      this.togglecounter_left =
        (237 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      this.togglecounter_top =
        (862 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;

      // this.toggleonoff_width = (119 * this.calculatedWidth) / this.normalWidth;
      // this.toggleonoff_height = (60 * this.calculatedWidth) / this.normalWidth;
      // this.toggleonoff_left =
      //   (492 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      // this.toggleonoff_top =
      //   (860 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;

      this.genericbuttontop =
        (407 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;
      this.button_2cm =
        (1264 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      this.button_10cm =
        (1388 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;

      this.info_material_left =
        (1548 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      this.info_material_top =
        (900 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;
      this.info_kilde_left =
        (1360 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      this.info_kilde_top =
        (61 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;
      this.info_avstand_left =
        (1390 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      this.info_avstand_top =
        (400 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;
      this.info_av_og_paa_left =
        (300 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      this.info_av_og_paa_top =
        (590 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;

      this.radiationsize = (168 * this.calculatedWidth) / this.normalWidth;

      this.fullscreen_button_left =
        (1788 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      this.fullscreen_button_top =
        (0 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;

      this.info_button_left =
        (20 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      this.info_button_top =
        (0 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;

      this.overskrift_left =
        (150 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      this.overskrift_top =
        (20 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;

      this.onoff_x =
        (487 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      this.onoff_y =
        (863.5 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;
      this.counter_x =
        (232 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      this.counter_y =
        (861 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;
      this.radius_threshold = (35 * this.calculatedWidth) / this.normalWidth;

      this.choose_radiation_text_x =
        (1560 * this.calculatedWidth) / this.normalWidth;
      this.choose_radiation_text_y =
        (100 * this.calculatedHeight) / this.normalHeight;

      // ------------------------------------

      // 2 cm
      // alfa, gamma // left 1006 top 165
      // beta left 1002  top 161
      let radiationleft = 0;
      let radiationtop = 0;
      let radiationwidth = 0;
      if (this.selectedavstand == "kort") {
        if (this.selectedstraalingsobjekt == "beta") {
          radiationleft = 1002;
          radiationtop = 161;
          radiationwidth = 750;
        } else {
          radiationleft = 1006;
          radiationtop = 165;
          radiationwidth = 750;
        }
      } else {
        radiationleft = 1170;
        radiationtop = 165;
        radiationwidth = 750;
      }
      this.radiation_width =
        (radiationwidth * this.calculatedWidth) / this.normalWidth;
      this.radiation_left =
        (radiationleft * this.calculatedWidth) / this.normalWidth +
        this.airgapLeft;
      this.radiation_top =
        (radiationtop * this.calculatedHeight) / this.normalHeight +
        this.airgapAbove;

      // ------------------------------------

      this.veggmaterial_width = (750 * this.calculatedWidth) / this.normalWidth;
      this.veggmaterial_left =
        (585 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      this.veggmaterial_top =
        (0 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;

      this.powerbutton_icon_width =
        (130 * this.calculatedWidth) / this.normalWidth;
      this.powerbutton_icon_left =
        (426 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      this.powerbutton_icon_top =
        (825 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;

      this.speaker_width = (52 * this.calculatedWidth) / this.normalWidth;
      this.speaker_signal_width =
        (83 * this.calculatedWidth) / this.normalWidth;
      this.speaker_left =
        (220 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      this.speaker_top =
        (722 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;

      this.countervalue_width = (197 * this.calculatedWidth) / this.normalWidth;
      this.countervalue_height =
        (111 * this.calculatedWidth) / this.normalWidth;
      this.countervalue_x =
        (350 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      this.countervalue_y =
        (668 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;

      this.countdownvalue_width =
        (68 * this.calculatedWidth) / this.normalWidth;
      this.countdownvalue_height =
        (60 * this.calculatedWidth) / this.normalWidth;

      this.countdownvalue_x =
        (326 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      this.countdownvalue_y =
        (833 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;

      if (this.selectedavstand == "kort") {
        this.linjal_arrow_x =
          (1008 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
        this.linjal_arrow_y =
          (752 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;
      } else {
        this.linjal_arrow_x =
          (1468 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
        this.linjal_arrow_y =
          (730 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;
      }

      // materialer
      // on hover 894 ~30px
      this.materialtop =
        (923 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;
      // papir
      this.veggmaterial.papir.iconleft =
        (1202 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      // kopper
      this.veggmaterial.kopper.iconleft =
        (1344 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      // aluminium
      this.veggmaterial.aluminium.iconleft =
        (1477 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      // bly
      this.veggmaterial.bly.iconleft =
        (1614 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      // kjøtt
      this.veggmaterial.meat.iconleft =
        (1752 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;

      // this.straalingsobjekt.alpha.iconleft = 500;
      // straalingsobjekter
      this.radiationtop =
        (80 * this.calculatedHeight) / this.normalHeight + this.airgapAbove;
      //alpha
      this.straalingsobjekter.alpha.iconleft =
        (1092 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      // beta
      this.straalingsobjekter.beta.iconleft =
        (1277 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      // gamma
      this.straalingsobjekter.gamma.iconleft =
        (1463 * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
    },
    mousemove(event) {
      let x = event.clientX;
      let y = event.clientY;
      let radiusfrommaterial =
        ((135 / 2) * this.calculatedWidth) / this.normalWidth;
      let radiusfromstraaling =
        ((168 / 2) * this.calculatedWidth) / this.normalWidth;
      let distanceFrom2cm = Math.sqrt(
        Math.pow(this.calculateNewXValue(1017) - x, 2) +
          Math.pow(this.calculateNewYValue(780) - y, 2),
      );
      let distanceFrom10cm = Math.sqrt(
        Math.pow(this.calculateNewXValue(1488) - x, 2) +
          Math.pow(this.calculateNewYValue(753) - y, 2),
      );

      let distanceFromPapir = Math.sqrt(
        Math.pow(this.calculateNewXValue(1202 + radiusfrommaterial) - x, 2) +
          Math.pow(this.calculateNewYValue(985 + radiusfrommaterial) - y, 2),
      );
      let distanceFromKopper = Math.sqrt(
        Math.pow(this.calculateNewXValue(1344 + radiusfrommaterial) - x, 2) +
          Math.pow(this.calculateNewYValue(985 + radiusfrommaterial) - y, 2),
      );
      let distanceFromAluminium = Math.sqrt(
        Math.pow(this.calculateNewXValue(1477 + radiusfrommaterial) - x, 2) +
          Math.pow(this.calculateNewYValue(985 + radiusfrommaterial) - y, 2),
      );

      let distanceFromBly = Math.sqrt(
        Math.pow(this.calculateNewXValue(1614 + radiusfrommaterial) - x, 2) +
          Math.pow(this.calculateNewYValue(985 + radiusfrommaterial) - y, 2),
      );
      let distanceFromMeat = Math.sqrt(
        Math.pow(this.calculateNewXValue(1752 + radiusfrommaterial) - x, 2) +
          Math.pow(this.calculateNewYValue(985 + radiusfrommaterial) - y, 2),
      );

      // strålingsobjekter
      let distanceFromAlfa = Math.sqrt(
        Math.pow(this.calculateNewXValue(1092 + radiusfromstraaling) - x, 2) +
          Math.pow(this.calculateNewYValue(80 + radiusfromstraaling) - y, 2),
      );
      let distanceFromBeta = Math.sqrt(
        Math.pow(this.calculateNewXValue(1277 + radiusfromstraaling) - x, 2) +
          Math.pow(this.calculateNewYValue(80 + radiusfromstraaling) - y, 2),
      );
      let distanceFromGamma = Math.sqrt(
        Math.pow(this.calculateNewXValue(1463 + radiusfromstraaling) - x, 2) +
          Math.pow(this.calculateNewYValue(80 + radiusfromstraaling) - y, 2),
      );
      this.data.veggobjekter.find((el) => el.value == "papir").hover =
        distanceFromPapir < radiusfrommaterial ? true : false;
      this.data.veggobjekter.find((el) => el.value == "kopper").hover =
        distanceFromKopper < radiusfrommaterial ? true : false;
      this.data.veggobjekter.find((el) => el.value == "aluminium").hover =
        distanceFromAluminium < radiusfrommaterial ? true : false;
      this.data.veggobjekter.find((el) => el.value == "bly").hover =
        distanceFromBly < radiusfrommaterial ? true : false;
      this.data.veggobjekter.find((el) => el.value == "meat").hover =
        distanceFromMeat < radiusfrommaterial ? true : false;

      // this.data.straaleobjekter.find(el => el.value == "alpha").hover =
      //   distanceFromAlfa < radiusfromstraaling ? true : false;
      // this.data.straaleobjekter.find(el => el.value == "beta").hover =
      //   distanceFromBeta < radiusfromstraaling ? true : false;
      // this.data.straaleobjekter.find(el => el.value == "gamma").hover =
      //   distanceFromGamma < radiusfromstraaling ? true : false;

      this.hover2cm =
        distanceFrom2cm < this.calculateNewXValue(20) ? true : false;
      this.hover10cm =
        distanceFrom10cm < this.calculateNewXValue(24) ? true : false;
    },
    calculateNewXValue(x_value) {
      let newValue =
        (x_value * this.calculatedWidth) / this.normalWidth + this.airgapLeft;
      return newValue;
    },
    calculateNewYValue(y_value) {
      let newValue =
        (y_value * this.calculatedHeight) / this.normalHeight +
        this.airgapAbove;
      return newValue;
    },
    clickedWindow(event) {
      let distanceFromOnOff = Math.sqrt(
        Math.pow(Math.abs(this.onoff_x) - Math.abs(event.clientX), 2) +
          Math.pow(Math.abs(this.onoff_y) - Math.abs(event.clientY), 2),
      );
      let distanceFromCounter = Math.sqrt(
        Math.pow(Math.abs(this.counter_x) - Math.abs(event.clientX), 2) +
          Math.pow(Math.abs(this.counter_y) - Math.abs(event.clientY), 2),
      );
      let distanceFrom2cm = Math.sqrt(
        Math.pow(
          Math.abs(this.calculateNewXValue(1017)) - Math.abs(event.clientX),
          2,
        ) +
          Math.pow(
            Math.abs(this.calculateNewYValue(780)) - Math.abs(event.clientY),
            2,
          ),
      );
      let distanceFrom10cm = Math.sqrt(
        Math.pow(
          Math.abs(this.calculateNewXValue(1488)) - Math.abs(event.clientX),
          2,
        ) +
          Math.pow(
            Math.abs(this.calculateNewYValue(753)) - Math.abs(event.clientY),
            2,
          ),
      );
      if (distanceFromOnOff < this.radius_threshold) {
        this.toggleOnOff();
      } else if (distanceFromCounter < this.radius_threshold) {
        this.toggleCounter();
      } else if (distanceFrom2cm < this.calculateNewXValue(20)) {
        this.selectedavstand = "kort";
        this.setValues();
      } else if (distanceFrom10cm < this.calculateNewXValue(24)) {
        this.selectedavstand = "lang";
        this.setValues();
      }
    },
    toggleOnOff() {
      this.on = !this.on;
      if (!this.on) {
        clearTimeout(this.countdown_timer);
        clearTimeout(this.countertimer);
        clearTimeout(this.triggertimer);
        clearInterval(this.counter_check_value);
        clearInterval(this.announce_timer);
        this.announced_counter_value = null;
        this.announced_counter_done = false;
      } else {
        this.counter_value = 0;
        this.countdown_value = 10;
        this.setValues();
      }
    },
    toggleSpeaker() {
      this.speaker_sound = !this.speaker_sound;
    },
    focusAvstand(index) {
      this.focusedAvstandIndex = index;
      this.$nextTick(() => {
        const el = document.getElementById(index === 0 ? 'button_2cm' : 'button_10cm');
        if (el) el.focus();
      });
    },
    confirmAvstand() {
      this.selectedavstand = this.focusedAvstandIndex === 0 ? 'kort' : 'lang';
      // watcher håndterer setValues automatisk
    },

    // Roving tabindex for geigerteller-gruppe
    // 0=av/på, 1=lyd, 2=start (kun tilgjengelig når on=true)
    geigerFocusNext() {
      if (!this.on && this.geigerFocusIndex === 1) {
        // start ikke tilgjengelig, wrap tilbake til 0
        this.geigerFocusIndex = 0;
      } else {
        const max = this.on ? 2 : 1;
        this.geigerFocusIndex = this.geigerFocusIndex >= max ? 0 : this.geigerFocusIndex + 1;
      }
      this.geigerFocusElement();
    },

    geigerFocusPrev() {
      if (!this.on && this.geigerFocusIndex === 0) {
        // start ikke tilgjengelig, wrap til lyd
        this.geigerFocusIndex = 1;
      } else {
        const max = this.on ? 2 : 1;
        this.geigerFocusIndex = this.geigerFocusIndex <= 0 ? max : this.geigerFocusIndex - 1;
      }
      this.geigerFocusElement();
    },

    geigerFocusElement() {
      this.$nextTick(() => {
        const ids = ['toggleonoff', 'togglespeaker', 'togglecounter'];
        const el = document.getElementById(ids[this.geigerFocusIndex]);
        if (el) el.focus();
      });
    },
    setValues() {
      clearTimeout(this.countertimer);
      clearTimeout(this.triggertimer);
      clearInterval(this.countdown_timer);
      clearInterval(this.counter_check_value);
      this.counter = false;

      this.targetValue = Math.floor(
        Math.random() *
          (this.data.straalingsobject[this.selectedstraalingsobjekt][
            this.selectedavstand
          ][this.selectedveggobjekt].max -
            this.data.straalingsobject[this.selectedstraalingsobjekt][
              this.selectedavstand
            ][this.selectedveggobjekt].min) +
          this.data.straalingsobject[this.selectedstraalingsobjekt][
            this.selectedavstand
          ][this.selectedveggobjekt].min,
      );
      if (this.targetValue > 0 && this.on) {
        var lambda = 10000 / this.targetValue;
        this.triggertimer = setTimeout(() => {
          this.triggerClick();
        }, lambda);
      }

      this.calculateAllValuesForImage();
    },
    checkcountdown() {
      if (this.counter) {
        let currentime = new Date().valueOf();
        let diff = currentime - this.countdown_start;
        diff = Math.round(diff / 1000);
        this.countdown_value = Math.max(0, 10 - diff);
        // this.countdown_value = 10 - diff;
      }
    },
    triggerClick() {
      clearTimeout(this.triggertimer);
      if (this.speaker_sound == true) {
        var snd = new Audio(
          "data:audio/wav;base64,UklGRnwAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YVgAAAAAAEsAKQFlAooD+wMhA5cAZvwY98rx/+1r7Y/xZ/sUC7wfgTfIT5NlBXbcftx+BXaTZchPgTe8HxQLZ/uP8Wvt/+3K8Rj3ZvyXACED+wOKA2UCKQFLAAAA",
        );

        snd.play();
        this.speaker_signal_show = true;
        clearTimeout(this.speaker_signal_timeout);
        this.speaker_signal_timeout = setTimeout(() => {
          this.speaker_signal_show = false;
        }, 20);
      }
      // var elm = document.querySelector("#speaker_signals");
      // var newone = elm.cloneNode(true);
      // elm.parentNode.replaceChild(newone, elm);
      var lambda = this.targetValue / 10000;
      var mean = 10000 / this.targetValue;
      let NextTime = -Math.log(1 - Math.random()) / lambda;
      if (this.counter) {
        let timepassed = new Date().valueOf() - this.countdown_start;
        let shouldbe = Math.floor(timepassed / mean);
        if (mean > 20) {
          this.counter_value++;
        } else {
          this.counter_value += shouldbe - this.counter_value;
        }
      }

      if (this.on && this.targetValue > 0) {
        this.triggertimer = setTimeout(() => {
          this.triggerClick();
        }, Math.floor(NextTime));
      }
    },
    toggleCounter() {
      this.setValues();
      this.counter = true;
      clearTimeout(this.countertimer);
      clearInterval(this.counter_check_value);
      clearInterval(this.announce_timer);
      this.announced_counter_value = null;
      this.announced_counter_done = false;
      if (this.on && this.counter) {
        this.counter_value = 0;
        this.countdown_start = new Date().valueOf();
        this.countdown_timer = setInterval(() => {
          this.checkcountdown();
        }, 100);
        // Annonserer teller-verdien til skjermleser hvert 3. sekund
        this.announce_timer = setInterval(() => {
          this.announced_counter_done = false;
          this.announced_counter_value = this.counter_value;
        }, 3000);
        this.countertimer = setTimeout(() => {
          this.counter = false;
          clearInterval(this.countdown_timer);
          clearInterval(this.counter_check_value);
          clearInterval(this.announce_timer);
          // Annonserer sluttresultatet med egen tekst
          this.announced_counter_done = true;
          this.announced_counter_value = this.counter_value;
        }, 10000);
      }
    },
    transformRange(value, maxsize = 60, minsize = 20) {
      var scale = (maxsize - minsize) / (600 - 200);
      return Math.floor((value - 200) * scale);
    },
    selectMaterial(value) {
      this.selectedveggobjekt =
        this.selectedveggobjekt != value && value ? value : "ingen";
      this.setValues();
    },
    selectedRadiation(value) {
      this.selectedstraalingsobjekt =
        this.selectedstraalingsobjekt != value && value ? value : "ingen";
      this.setValues();
    },

    // Arrow key navigation for materialer - flytter kun fokus, Enter/Space velger
    selectNextMaterial() {
      const next = (this.focusedMaterialIndex + 1) % this.visibleMaterials.length;
      this.focusedMaterialIndex = next;
      this.focusMaterialElement(next);
    },
    selectPrevMaterial() {
      const len = this.visibleMaterials.length;
      const prev = this.focusedMaterialIndex <= 0 ? len - 1 : this.focusedMaterialIndex - 1;
      this.focusedMaterialIndex = prev;
      this.focusMaterialElement(prev);
    },
    selectFirstMaterial() {
      this.focusedMaterialIndex = 0;
      this.focusMaterialElement(0);
    },
    selectLastMaterial() {
      const last = this.visibleMaterials.length - 1;
      this.focusedMaterialIndex = last;
      this.focusMaterialElement(last);
    },
    confirmMaterial() {
      const material = this.visibleMaterials[this.focusedMaterialIndex];
      if (material) {
        this.selectedveggobjekt =
          this.selectedveggobjekt === material.value ? 'ingen' : material.value;
        this.setValues();
      }
    },
    focusMaterialElement(index) {
      this.$nextTick(() => {
        const els = document.querySelectorAll('.veggmaterial_container[role="radio"]');
        if (els[index]) els[index].focus();
      });
    },

    // Arrow key navigation for strålekilder
    selectNextRadiation() {
      const radiation = this.visibleRadation;
      const currentIndex = radiation.findIndex(
        (r) => r.value === this.selectedstraalingsobjekt,
      );
      const next = (this.focusedRadiationIndex + 1) % this.visibleRadation.length;
      this.focusedRadiationIndex = next;
      this.focusRadiationElement(next);
    },

    selectPrevRadiation() {
      const len = this.visibleRadation.length;
      const prev = this.focusedRadiationIndex <= 0 ? len - 1 : this.focusedRadiationIndex - 1;
      this.focusedRadiationIndex = prev;
      this.focusRadiationElement(prev);
    },

    selectFirstRadiation() {
      this.focusedRadiationIndex = 0;
      this.focusRadiationElement(0);
    },

    selectLastRadiation() {
      const last = this.visibleRadation.length - 1;
      this.focusedRadiationIndex = last;
      this.focusRadiationElement(last);
    },

    confirmRadiation() {
      const radiation = this.visibleRadation[this.focusedRadiationIndex];
      if (radiation) {
        this.selectedstraalingsobjekt =
          this.selectedstraalingsobjekt === radiation.value ? 'ingen' : radiation.value;
        this.setValues();
      }
    },

    focusRadiationElement(index) {
      this.$nextTick(() => {
        const els = document.querySelectorAll('.straaleobjekt_container[role="radio"]');
        if (els[index]) els[index].focus();
      });
    },


    wrapFocusToStart() {
      const el = document.getElementById('infobutton');
      if (el) el.focus();
    },
    showInfo() {
      this.modal.show = true;
    },
    toggleFullScreen() {
      var doc = window.document;
      var docEl = doc.documentElement;

      var requestFullScreen =
        docEl.requestFullscreen ||
        docEl.mozRequestFullScreen ||
        docEl.webkitRequestFullScreen ||
        docEl.msRequestFullscreen;
      var cancelFullScreen =
        doc.exitFullscreen ||
        doc.mozCancelFullScreen ||
        doc.webkitExitFullscreen ||
        doc.msExitFullscreen;

      if (
        !doc.fullscreenElement &&
        !doc.mozFullScreenElement &&
        !doc.webkitFullscreenElement &&
        !doc.msFullscreenElement
      ) {
        requestFullScreen.call(docEl);
      } else {
        cancelFullScreen.call(doc);
      }
    },
    keydown(event) {
      // Blokker sidescrolling fra piltaster når et navigerbart element har fokus
      const activeEl = document.activeElement;
      const role = activeEl && activeEl.getAttribute("role");
      const geigerIds = ['toggleonoff', 'togglecounter', 'togglespeaker'];
      const isGeigerEl = activeEl && geigerIds.includes(activeEl.id);
      if (
        activeEl &&
        (role === "radio" || isGeigerEl) &&
        [
          this.keyUp,
          this.keyDown,
          this.keyLeft,
          this.keyRight,
          this.keyHome,
          this.keyEnd,
        ].includes(event.which || event.keyCode)
      ) {
        event.preventDefault();
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.triggertimer);
    clearTimeout(this.countertimer);
    clearInterval(this.counter_check_value);
    clearInterval(this.announce_timer);
    window.removeEventListener("resize", this.calculateSizes);
    // window.removeEventListener("click", this.clickedWindow);
    // window.removeEventListener("mousemove", this.mousemove);
    window.removeEventListener("keydown", this.keydown);
  },
};
</script>

<style>
/* Usynlig wrapper kun for gruppering i DOM – children er absolutt-posisjonert og synlig */
.sr-only-group {
  position: absolute;
  width: 0;
  height: 0;
  overflow: visible;
}

/* Screen reader only - hides content visually but keeps it accessible to screen readers */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}


/* Focus indicators - WCAG 2.4.7 - minimum 3:1 kontrast */
*:focus-visible {
  outline: 3px solid #000000;
  outline-offset: 2px;
  box-shadow: 0 0 0 5px rgba(255, 255, 255, 0.8);
}

/* Skjul outline ved museklikk, vis kun ved tastaturnavigasjon */
*:focus:not(:focus-visible) {
  outline: none;
  box-shadow: none;
}

/* Radio buttons i radiogroups */
[role="radio"]:focus-visible {
  outline: 3px solid #000000;
  outline-offset: 4px;
  box-shadow: 0 0 0 6px rgba(255, 255, 255, 0.9);
  z-index: 9999;
}

/* Power button og counter - ekstra tydelig */
#toggleonoff:focus-visible,
#togglecounter:focus-visible {
  outline: 4px solid #ff6600;
  outline-offset: 3px;
  box-shadow: 0 0 0 7px rgba(255, 255, 255, 0.8),
    0 0 12px rgba(255, 102, 0, 0.5);
}

html,
body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  font-size: 18px;
  height: 100vh;
  width: 100vw;
  font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;
}
h1,
.h1 {
  font-size: 2.1rem;
  font-weight: 600;
}
h2,
.h2 {
  font-size: 1.22rem;
  font-weight: 700;
}
h3,
.h3 {
  font-size: 1rem;
  font-weight: 700;
}
.ingress {
  font-size: 1.44rem;
  font-weight: 300;
}
.overskrift {
  position: absolute;
}
.overskrift h1,
.overskrift h2 {
  margin: 0;
  padding: 0;
  color: white;
}
.overskrift h1 {
  text-decoration: underline;
}
@media (max-width: 899px) {
  html,
  body {
    font-size: 16px;
    overflow: initial;
  }

  h1,
  .h1 {
    font-size: 1.2rem;
  }
  h2,
  .h2 {
    font-size: 0.8rem;
  }
}

#app {
  margin: 0;
  padding: 0;
  background-image: url("~@/assets/img/BackplateV6_utenKnapp.png");
}
#on_button {
  background-image: url("~@/assets/img/Knapp_Pa2.png");
}
#off_button {
  background-image: url("~@/assets/img/Knapp_Av.png");
}
#counter_button {
  background-image: url("~@/assets/img/Count_ON_Full.png");
}
/* #speaker_signals {
  opacity: 0;
  background-image: url("~@/assets/img/SpeakerSignals.png");
  animation: signal_fade 0.01s;
}
@keyframes signal_fade {
  0% {
    opacity: 100%;
  }
  100% {
    opacity: 0%;
  }
} */

#linjal_2cm {
  background-image: url("~@/assets/img/Linjal_2cm.png");
}
#linjal_10cm {
  background-image: url("~@/assets/img/Linjal_10cm.png");
}
.blinking {
  /* animation: blinkingText 0.6s infinite; */
}
@keyframes blinkingText {
  0% {
    opacity: 1;
  }
  49% {
    opacity: 1;
  }
  60% {
    opacity: 0;
  }
  99% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.imagecontainer {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  position: absolute;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

#geiger {
  /* background-image: url("~@/assets/img/Geiger.png"); */
}
#material {
  /* background-image: url("~@/assets/img/Materiale.png"); */
}
#radiation {
  /* background-image: url("~@/assets/img/Betakilde.png"); */
}
#togglecounter {
  transform: translate(-50%, -50%);
  /* background-color: green; */
}
.hiddenfromview,
div.veggmaterial_container,
div.straaleobjekt_container {
  position: absolute;
  z-index: 998;
}
img.veggmaterial,
img.straaleobjekt,
span.straaleobjekt,
.veggmaterial_span,
.straaleobjekt_span,
.genericbutton,
.genericbutton_span,
#geigercountdown,
#geigercountdown_span,
#geigercounter,
#geigercounter_span {
  position: absolute;
  z-index: 999;
}
img.straaleobjekt {
  /* display: none; */
}
img.straaleobjekt.glow {
  display: initial;
}
#geigercounter,
#geigercountdown {
  text-align: center;
  /* background-color: green; */
}
#geigercounter_span {
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 2rem;
}
#geigercountdown_span {
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.5rem;
}
@media (min-width: 1200px) {
  #geigercounter_span {
    font-size: 3rem;
  }
  #geigercountdown_span {
  }
}

.genericbutton_span {
  /* display: none; */
  transform: translate(-50%, -50%);
  font-size: 1rem;
  font-weight: 300;
  /* opacity: 0.3; */
  background: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  padding: 0 5px;
  font-size: 1rem;
  /* text-shadow: 2px 2px 10px black, 2px 2px 20px black, 2px 2px 20px black,
    -2px -2px 20px black, 2px -2px 20px black, -2px 2px 20px black; */
  /* letter-spacing: 0.2em; */
  color: black;
}

.genericbutton_span.hover {
  display: initial;
  opacity: 1;
}

#infobutton_span,
#fullscreenbutton_span {
  transform: translate(-50%, -50%);
  /* text-shadow: 2px 2px 10px black, 2px 2px 20px black, 2px 2px 20px black,
    -2px -2px 20px black, 2px -2px 20px black, -2px 2px 20px black; */
  /* letter-spacing: 0.2em; */
  color: white;
}

.veggmaterial_span {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: bold;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  padding: 0 5px;
  font-size: 1rem;
}
.straaleobjekt_span {
  /* transform: translate(-50%, 150%); */
  top: 75%;
  left: 50%;
  transform: translate(-50%, -25%);
  font-weight: bold;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  padding: 0 5px;
  font-size: 1rem;
}
@media (max-width: 899px) {
  .genericbutton_span,
  .straaleobjekt_span,
  .veggmaterial_span {
    font-size: 0.5rem;
  }
}
.genericbutton_span.hover,
.veggmaterial_span.hover,
.straaleobjekt_span.hover {
  /* display: initial; */
  /* text-decoration: underline; */
  border-bottom: 4px solid black;
  /* transform: translate(-50%, calc(50% - 2px)); */
}
img.veggmaterial.hover {
  /* transform: translateY(-25%); */
  /* border: 3px solid black; */
  /* border-radius: 50%; */
}

.dropdown {
  position: absolute;
  display: inline-block;
}
.straaleobjekt.dropdown {
  right: 20%;
}

.material.dropdown {
  left: 20%;
}
.dropdownwrapper {
  display: flex;
}
.dropdownwrapper > span {
  align-self: center;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.9);
  min-width: 200px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 12px 16px;
  z-index: 99999;
  font-size: 0.8rem;
}
@media (max-width: 899px) {
  .dropdown-content {
    font-size: 0.55rem;
  }
}
.dropdown-content.slim {
  min-width: 0;
  z-index: 999999;
}
.veggmaterial_container .dropdown-content {
  bottom: 100%;
}

.dropdown:hover .dropdown-content,
.dropdown.focus .dropdown-content {
  display: block;
}

.info.tekst {
  color: black;
  opacity: 1;
  position: absolute;
  /* z-index: 999; */
  transform: translate(-50%, -50%);
  white-space: nowrap;
  /* min-width: 200px; */
  /* text-align: center; */
}

.info.tekst.left {
  transform: translate(0%, -50%);
}

.info.tekst:hover,
.info.tekst.focus {
  z-index: 999;
}
.info.tekst .h2 {
  text-decoration: underline;
}
.info.tekst .dropdown-content {
  white-space: initial;
}
#info_material .dropdown-content {
  transform: translate(-100%, -75%);
}

#info_av_og_paa .dropdown-content {
  transform: translate(65%, 0%);
}
#info_avstand .dropdown-content {
  transform: translateX(-50%);
}

.straaleobjekt_container .dropdown-content {
  /* transform: translate(100%, -50%); */
  top: 100%;
}
.linjal_arrow {
  position: absolute;
  transform: translate(-50%, -100%);
}
.focus {
  outline-color: black;
  outline-style: solid;
  outline-offset: -3px;
  outline-width: 3px;
}
.straaleobjekt_container,
.veggmaterial_container,
#button_2cm,
#button_2cm_span,
#button_10cm,
#button_10cm_span,
#toggleonoff,
#togglecounter,
#fullscreenbutton,
#fullscreenbutton_span,
#infobutton,
#infobutton_span {
  cursor: pointer;
}
</style>
